const cadesServer = process.env.VUE_APP_CADES_SERVER;
const clientServer = process.env.VUE_APP_CADES_CLIENT;
const appId = process.env.VUE_APP_CADES_ID;
const tokenKey = `token`;
const b64ToJsonStr = str => window.atob(str);


async function cades(path, data) {
  const reqOpts = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      accept: 'application/json',
    },
  };
  const response = await fetch(`${cadesServer}${path}`, reqOpts).then(res => res.json());
  if (response.errors) {
    throw new Error(response.errors[0].message);
  }
  return response.data;
}


const state = {
  token: null,
  expiresAt: null,
};

const getters = {
  isLoggedIn: state => () => state.token && state.expiresAt > window.DATE.getTime(),
};

const mutations = {
  setToken(state, token) {
    const clearToken = () => {
      state.token = null;
      state.expiresAt = null;
      window.localStorage.removeItem(tokenKey);
    }

    if (!token) {
      return clearToken();
    }

    try {
      const payload = token.split('.')[1];
      const decoded = JSON.parse(b64ToJsonStr(payload));
      const expiresAt = new Date(decoded.exp * 1000).getTime();

      if (window.DATE.getTime() > expiresAt) {
        // token expirado
        return clearToken();
      }

      state.token = token;
      state.expiresAt = expiresAt;
      window.localStorage.setItem(tokenKey, token);
    } catch (e) {
      clearToken();
    }
  },
};

const actions = {
  async load({ commit, dispatch }) {
    // si estamos en /auth, guardamos el token en el localstorage
    if (window.location.pathname === '/auth') {
      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get('token');
      window.localStorage.setItem('token', token);
      // cambiamos url a home. Esto no genera refresh, la ejecución del codigo continua.
      window.history.replaceState(null, null, '/');
    }
    const token = window.localStorage.getItem('token');
    if (!token) {
      return dispatch('logout');
    }
    window.DATE = new Date();
    try {
      const dateReq = await fetch(`${cadesServer}/time`);
      if (dateReq.ok) {
        const serverDate = await dateReq.text();
        window.DATE = new Date(serverDate.replace(/['"]+/g, ''));
      }
    } catch (e) {}
    window.setInterval(function () {
      window.DATE.setSeconds(window.DATE.getSeconds() + 1);
    }, 1000);

    try {
      const payload = token.split('.')[1];
      const payloadStr = window.atob(payload);
      const decoded = JSON.parse(payloadStr);
      const expiresAt = new Date(decoded.exp * 1000);
      if (window.DATE.getTime() > expiresAt.getTime()) {
        // token expirado
        throw new Error('token expirado');
      }
      return commit('setToken', token);
    } catch (e) {
      return dispatch('logout');
    }
  },
  async ensureSession({ getters, dispatch }) {
    if (!getters.isLoggedIn()) {
      return dispatch('logout');
    }
  },
  async refresh({ state, commit, getters }) {
    if (!getters.isLoggedIn()) {
      return;
    }
    const { token } = await cades('/api/auth-refresh', { appId, token: state.token });
    commit('setToken', token);
  },
  async logout({ commit }) {
    // aseguramos que la sesión este cerrada antes de mostrar login
    window.onbeforeunload = null;
    window.localStorage.removeItem('token');
    commit('setToken', null);
    window.location.replace(`${clientServer}/login?appId=${appId}`);
    // la redirección es asincrona. Para evitar que continue la ejecución, retornamos una promesa que nunca adquire un valor
    return new Promise(() => {});
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
